webpackJsonp([2],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _adLoader = __webpack_require__(30);
	
	__webpack_require__(33);
	
	__webpack_require__(29);
	
	var _resizeWatcher = __webpack_require__(12);
	
	var _resizeWatcher2 = _interopRequireDefault(_resizeWatcher);
	
	var _scrollWatcher = __webpack_require__(39);
	
	var _scrollWatcher2 = _interopRequireDefault(_scrollWatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// constants
	var bgClassPrefix = 'bg-';
	
	// elements
	var body = document.body;
	var storyHeader = document.querySelector('.sty-header');
	
	// store
	var backgroundColorClass = body.className.split(' ').filter(function (cls) {
	  return cls.substr(0, bgClassPrefix.length) === bgClassPrefix;
	})[0];
	var storyHeaderHeight = storyHeader.getBoundingClientRect().height;
	var yOffset = window.scrollY || window.pageYOffset;
	
	_resizeWatcher2.default.add(function (d) {
	  storyHeaderHeight = storyHeader.getBoundingClientRect().height;
	
	  if (yOffset > storyHeaderHeight) {
	    body.classList.remove(backgroundColorClass);
	  } else {
	    body.classList.add(backgroundColorClass);
	  }
	});
	
	_scrollWatcher2.default.add(function (d) {
	  yOffset = d.offset;
	
	  if (yOffset > storyHeaderHeight) {
	    body.classList.remove(backgroundColorClass);
	  } else {
	    body.classList.add(backgroundColorClass);
	  }
	});
	
	_adLoader.AdLoader.init();

/***/ },

/***/ 29:
/***/ function(module, exports) {

	'use strict';
	
	(function (document, window, config) {
	
	  'use strict';
	
	  var _config = config || {};
	  var forceSyntax = _config.forceSyntax || 0;
	  var dataLayerName = _config.dataLayerName || 'dataLayer';
	  // Default configuration for events
	  var eventsFired = {
	    'Play': true,
	    'Pause': true,
	    'Watch to End': true
	  };
	  var key;
	
	  // Fetches YouTube JS API
	  var tag = document.createElement('script');
	  tag.src = '//www.youtube.com/iframe_api';
	  var firstScriptTag = document.getElementsByTagName('script')[0];
	  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	
	  for (key in _config.events) {
	
	    if (_config.events.hasOwnProperty(key)) {
	
	      eventsFired[key] = _config.events[key];
	    }
	  }
	
	  window.onYouTubeIframeAPIReady = function () {
	
	    var cached = window.onYouTubeIframeAPIReady;
	
	    return function () {
	
	      if (cached) {
	
	        cached.apply(this, arguments);
	      }
	
	      // This script won't work on IE 6 or 7, so we bail at this point if we detect that UA
	      if (navigator.userAgent.match(/MSIE [67]\./gi)) return;
	
	      if (document.readyState !== 'loading') {
	
	        init();
	      } else {
	
	        // On IE8 this fires on window.load, all other browsers will fire when DOM ready
	        if (document.addEventListener) {
	
	          addEvent(document, 'DOMContentLoaded', init);
	        } else {
	
	          addEvent(window, 'load', init);
	        }
	      }
	    };
	  }();
	
	  // Invoked by the YouTube API when it's ready
	  function init() {
	
	    var potentialVideos = getTagsAsArr_('iframe').concat(getTagsAsArr_('embed'));
	    digestPotentialVideos(potentialVideos);
	
	    // Will bind to dynamically added videos. CAPTURE NOT SUPPORTED BY IE8
	    if ('addEventListener' in document) {
	      document.addEventListener('load', bindToNewVideos_, true);
	    }
	  }
	
	  // Take our videos and turn them into trackable videos with events
	  function digestPotentialVideos(potentialVideos) {
	
	    var i;
	
	    for (i = 0; i < potentialVideos.length; i++) {
	
	      var isYouTubeVideo = checkIfYouTubeVideo(potentialVideos[i]);
	
	      if (isYouTubeVideo) {
	
	        var normalizedYouTubeIframe = normalizeYouTubeIframe(potentialVideos[i]);
	        addYouTubeEvents(normalizedYouTubeIframe);
	      }
	    }
	  }
	
	  // Determine if the element is a YouTube video or not
	  function checkIfYouTubeVideo(potentialYouTubeVideo) {
	
	    var potentialYouTubeVideoSrc = potentialYouTubeVideo.src || '';
	
	    if (potentialYouTubeVideoSrc.indexOf('youtube.com/embed/') > -1 || potentialYouTubeVideoSrc.indexOf('youtube.com/v/') > -1) {
	
	      return true;
	    }
	
	    return false;
	  }
	
	  function jsApiEnabled(url) {
	
	    return url.indexOf('enablejsapi') > -1;
	  }
	
	  function originEnabled(url) {
	
	    return url.indexOf('origin') > -1;
	  }
	
	  // Turn embed objects into iframe objects and ensure they have the right parameters
	  function normalizeYouTubeIframe(youTubeVideo) {
	
	    var loc = window.location;
	    var a = document.createElement('a');
	    a.href = youTubeVideo.src;
	    a.hostname = 'www.youtube.com';
	    a.protocol = loc.protocol;
	    var tmpPathname = a.pathname.charAt(0) === '/' ? a.pathname : '/' + a.pathname; // IE10 shim
	
	    // For security reasons, YouTube wants an origin parameter set that matches our hostname
	
	    if (!jsApiEnabled(a.search)) {
	
	      a.search = (a.search.length > 0 ? a.search + '&' : '') + 'enablejsapi=1';
	    }
	
	    if (!originEnabled(a.search) && loc.hostname.indexOf('localhost') === -1) {
	
	      var port = loc.port ? ':' + loc.port : '';
	      var origin = loc.protocol + '%2F%2F' + loc.hostname + port;
	
	      a.search = a.search + '&origin=' + origin;
	    }
	
	    if (youTubeVideo.type === 'application/x-shockwave-flash') {
	
	      var newIframe = document.createElement('iframe');
	      newIframe.height = youTubeVideo.height;
	      newIframe.width = youTubeVideo.width;
	      tmpPathname = tmpPathname.replace('/v/', '/embed/');
	
	      youTubeVideo.parentNode.parentNode.replaceChild(newIframe, youTubeVideo.parentNode);
	
	      youTubeVideo = newIframe;
	    }
	
	    a.pathname = tmpPathname;
	
	    if (youTubeVideo.src !== a.href + a.hash) {
	
	      youTubeVideo.src = a.href + a.hash;
	    }
	
	    return youTubeVideo;
	  }
	
	  // Add event handlers for events emitted by the YouTube API
	  function addYouTubeEvents(youTubeIframe) {
	
	    var player = YT.get(youTubeIframe.id);
	
	    if (!player) {
	
	      player = new YT.Player(youTubeIframe, {});
	    }
	
	    if (typeof youTubeIframe.pauseFlag === 'undefined') {
	
	      youTubeIframe.pauseFlag = false;
	      player.addEventListener('onStateChange', function (evt) {
	
	        onStateChangeHandler(evt, youTubeIframe);
	      });
	    }
	  }
	
	  // Returns key/value pairs of percentages: number of seconds to achieve
	  function getMarks(duration) {
	
	    var marks = {};
	
	    // For full support, we're handling Watch to End with percentage viewed
	    if (_config.events['Watch to End']) {
	
	      marks['Watch to End'] = Math.min(duration - 3, Math.floor(duration * 0.99));
	    }
	
	    if (_config.percentageTracking) {
	
	      var points = [];
	      var i;
	
	      if (_config.percentageTracking.each) {
	
	        points = points.concat(_config.percentageTracking.each);
	      }
	
	      if (_config.percentageTracking.every) {
	
	        var every = parseInt(_config.percentageTracking.every, 10);
	        var num = 100 / every;
	
	        for (i = 1; i < num; i++) {
	
	          points.push(i * every);
	        }
	      }
	
	      for (i = 0; i < points.length; i++) {
	
	        var _point = points[i];
	        var _mark = _point + '%';
	        var _time = duration * _point / 100;
	
	        marks[_mark] = Math.floor(_time);
	      }
	    }
	
	    return marks;
	  }
	
	  function checkCompletion(player, marks, videoId) {
	
	    var currentTime = player.getCurrentTime();
	    var key;
	
	    player[videoId] = player[videoId] || {};
	
	    for (key in marks) {
	
	      if (marks[key] <= currentTime && !player[videoId][key]) {
	
	        player[videoId][key] = true;
	        fireAnalyticsEvent(videoId, key);
	      }
	    }
	  }
	
	  // Event handler for events emitted from the YouTube API
	  function onStateChangeHandler(evt, youTubeIframe) {
	
	    var stateIndex = evt.data;
	    var player = evt.target;
	    var targetVideoUrl = player.getVideoUrl();
	    var targetVideoId = targetVideoUrl.match(/[?&]v=([^&#]*)/)[1]; // Extract the ID
	    var playerState = player.getPlayerState();
	    var duration = Math.floor(player.getDuration());
	    var marks = getMarks(duration);
	    var playerStatesIndex = {
	      '1': 'Play',
	      '2': 'Pause'
	    };
	    var state = playerStatesIndex[stateIndex];
	
	    youTubeIframe.playTracker = youTubeIframe.playTracker || {};
	
	    if (playerState === 1 && !youTubeIframe.timer) {
	
	      clearInterval(youTubeIframe.timer);
	
	      youTubeIframe.timer = setInterval(function () {
	
	        // Check every second to see if we've hit any of our percentage viewed marks
	        checkCompletion(player, marks, youTubeIframe.videoId);
	      }, 1000);
	    } else {
	
	      clearInterval(youTubeIframe.timer);
	      youTubeIframe.timer = false;
	    }
	
	    // Playlist edge-case handler
	    if (stateIndex === 1) {
	
	      youTubeIframe.playTracker[targetVideoId] = true;
	      youTubeIframe.videoId = targetVideoId;
	      youTubeIframe.pauseFlag = false;
	    }
	
	    if (!youTubeIframe.playTracker[youTubeIframe.videoId]) {
	
	      // This video hasn't started yet, so this is spam
	      return false;
	    }
	
	    if (stateIndex === 2) {
	
	      if (!youTubeIframe.pauseFlag) {
	
	        youTubeIframe.pauseFlag = true;
	      } else {
	
	        // We don't want to fire consecutive pause events
	        return false;
	      }
	    }
	
	    // If we're meant to track this event, fire it
	    if (eventsFired[state]) {
	
	      fireAnalyticsEvent(youTubeIframe.videoId, state);
	    }
	  }
	
	  // Fire an event to Google Analytics or Google Tag Manager
	  function fireAnalyticsEvent(videoId, state) {
	
	    var videoUrl = 'https://www.youtube.com/watch?v=' + videoId;
	    var _ga = window.GoogleAnalyticsObject;
	
	    if (typeof window[dataLayerName] !== 'undefined' && !_config.forceSyntax) {
	
	      window[dataLayerName].push({
	
	        'event': 'youTubeTrack',
	        'attributes': {
	
	          'videoUrl': videoUrl,
	          'videoAction': state
	
	        }
	
	      });
	    } else if (typeof window[_ga] === 'function' && typeof window[_ga].getAll === 'function' && _config.forceSyntax !== 2) {
	
	      window[_ga]('send', 'event', 'Videos', state, videoUrl);
	    } else if (typeof window._gaq !== 'undefined' && forceSyntax !== 1) {
	
	      window._gaq.push(['_trackEvent', 'Videos', state, videoUrl]);
	    }
	  }
	
	  // Simple cross-browser event listener
	  function addEvent(el, name, fn) {
	
	    if (el.addEventListener) {
	
	      el.addEventListener(name, fn);
	    } else if (el.attachEvent) {
	
	      el.attachEvent('on' + name, function (evt) {
	
	        evt.target = evt.target || evt.srcElement;
	        // Call the event to ensure uniform 'this' handling, pass it event
	        fn.call(el, evt);
	      });
	    } else if (typeof el['on' + name] === 'undefined' || el['on' + name] === null) {
	
	      el['on' + name] = function (evt) {
	
	        evt.target = evt.target || evt.srcElement;
	        // Call the event to ensure uniform 'this' handling, pass it event
	        fn.call(el, evt);
	      };
	    }
	  }
	
	  // Returns array of elements with given tag name
	  function getTagsAsArr_(tagName) {
	
	    return [].slice.call(document.getElementsByTagName(tagName));
	  }
	
	  function bindToNewVideos_(evt) {
	
	    var el = evt.target || evt.srcElement;
	    var isYT = checkIfYouTubeVideo(el);
	
	    // We only bind to iframes with a YouTube URL with the enablejsapi=1 and
	    // origin=<<hostname>> parameters
	    if (el.tagName === 'IFRAME' && isYT && jsApiEnabled(el.src) && originEnabled(el.src)) {
	
	      addYouTubeEvents(el);
	    }
	  }
	})(document, window, {
	  'events': {
	    'Play': true,
	    'Pause': true,
	    'Watch to End': true
	  },
	  'percentageTracking': {
	    'every': 25,
	    'each': [10, 90]
	  }
	});
	/*
	 * Configuration Details
	 *
	 * @property events object
	 * Defines which events emitted by YouTube API
	 * will be turned into Google Analytics or GTM events
	 *
	 * @property percentageTracking object
	 * Object with configurations for percentage viewed events
	 *
	 *   @property each array
	 *   Fires an event once each percentage ahs been reached
	 *
	 *   @property every number
	 *   Fires an event for every n% viewed
	 *
	 * @property forceSyntax int 0, 1, or 2
	 * Forces script to use Classic (2) or Universal(1)
	 *
	 * @property dataLayerName string
	 * Tells script to use custom dataLayer name instead of default
	 */
	/*
	 * v8.1.0
	 * Created by the Google Analytics consultants at http://www.lunametrics.com
	 * Written by @SayfSharif and @notdanwilkerson
	 * Documentation: https://github.com/lunametrics/youtube-google-analytics/
	 * Licensed under the Creative Commons 4.0 Attribution Public License
	 */

/***/ },

/***/ 30:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Converts a string from dash or underscore separated to camelCase.
	 *
	 * @private
	 * @param  {String} str
	 * @return {String}
	 */
	function camelCase(str) {
	  // remove any dashes or underscores in the string, and grab the following character
	  return str.replace(/[\-_]+(\w?)/g, function (match, p1) {
	    // uppercase the following letter
	    return p1.toUpperCase();
	  });
	}
	
	/**
	 * Gets all the attributes set on an element, and returns them as an Object.
	 *
	 * @private
	 * @param  {Element} element
	 * @return {Object}
	 */
	function getAttributes(element) {
	  var attrs = {};
	
	  // if element is empty, or not ELEMENT_NODE, eject
	  if (!element || element.nodeType !== 1) return attrs;
	
	  // grab all the attributes off the element
	  var map = element.attributes;
	
	  // if there are no attributes, eject
	  if (map.length === 0) return attrs;
	
	  // loop through the attributes and build the object
	  for (var i = 0; i < map.length; i++) {
	    attrs[map[i].name] = map[i].value;
	  }
	
	  return attrs;
	}
	
	/**
	 * Searches an element's attributes and returns an Object of all the ones that
	 * begin with a specified prefix. Each matching attribute name is returned
	 * without the prefix, with the remainder converted to camelCase.
	 *
	 * @private
	 * @param  {Element} element
	 * @param  {String} prefix
	 * @return {Object}
	 */
	function getMatchingAttributes(element, prefix) {
	  // get all the attributes on the element
	  var attributes = getAttributes(element);
	  var fields = {};
	
	  // loop through the keys of the attributes
	  Object.keys(attributes).forEach(function (key) {
	    // continue if the key begins with supplied prefix
	    if (key.substr(0, prefix.length) === prefix) {
	      // grab the value associated with the original key
	      var value = attributes[key];
	
	      // slice off the prefix and camelCase what is left
	      var field = camelCase(key.slice(prefix.length));
	
	      fields[field] = value;
	    }
	  });
	
	  return fields;
	}
	
	/**
	 * A helper for asynchronously loading scripts.
	 *
	 * Provides a callback interface for passing a function that will only be called
	 * if the script is successfully added to the page.
	 *
	 * @private
	 * @param {Element} global Typically `window` - the browser context to work
	 * within
	 * @param {String} url The URL for the script to be loaded.
	 * @param {Function} [cb] A function to be called once the script successfully
	 * loads. Not required.
	 * @returns {void}
	 * @example
	 *
	 * loadScript('backup.js', function () {
	 *   // anything that depends on that script loading
	 * })
	 */
	function loadScript(global, url, cb) {
	  // create the `script` element
	  var script = global.document.createElement('script');
	
	  // set its URL
	  script.src = url;
	
	  // if there is a supplied callback, add it to `onload`
	  if (cb) script.onload = cb;
	
	  // attach the script to the document body
	  global.document.body.appendChild(script);
	}
	
	// Sourced from: https://github.com/sindresorhus/object-assign
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
	  if (val === null || val === undefined) {
	    throw new TypeError('Object.assign cannot be called with null or undefined');
	  }
	
	  return Object(val);
	}
	
	function shouldUseNative() {
	  try {
	    if (!Object.assign) {
	      return false;
	    }
	
	    // Detect buggy property enumeration order in older V8 versions.
	
	    // https://bugs.chromium.org/p/v8/issues/detail?id=4118
	    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
	    test1[5] = 'de';
	    if (Object.getOwnPropertyNames(test1)[0] === '5') {
	      return false;
	    }
	
	    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
	    var test2 = {};
	    for (var i = 0; i < 10; i++) {
	      test2['_' + String.fromCharCode(i)] = i;
	    }
	    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
	      return test2[n];
	    });
	    if (order2.join('') !== '0123456789') {
	      return false;
	    }
	
	    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
	    var test3 = {};
	    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
	      test3[letter] = letter;
	    });
	    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
	      return false;
	    }
	
	    return true;
	  } catch (err) {
	    // We don't expect any of the above to throw, but better to be safe.
	    return false;
	  }
	}
	
	var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	  var from;
	  var to = toObject(target);
	  var symbols;
	
	  for (var s = 1; s < arguments.length; s++) {
	    from = Object(arguments[s]);
	
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	
	    if (Object.getOwnPropertySymbols) {
	      symbols = Object.getOwnPropertySymbols(from);
	      for (var i = 0; i < symbols.length; i++) {
	        if (propIsEnumerable.call(from, symbols[i])) {
	          to[symbols[i]] = from[symbols[i]];
	        }
	      }
	    }
	  }
	
	  return to;
	};
	
	/**
	 * Counter used by {uniqueId} to iterate.
	 *
	 * @private
	 * @type {Number}
	 */
	var idCounter = 0;
	
	/**
	 * Function for generating identifiers unique to a single browser session.
	 * Each time it runs, the integer at the end of the return value will increment.
	 *
	 * Borrowed from underscore.js: http://underscorejs.org/#uniqueId
	 *
	 * @param  {String} [prefix] Optional prefix for identifier
	 * @return {String}
	 * @example
	 * var identifier = uniqueId()
	 * // returns '1'
	 *
	 * var prefixedIdentifier = uniqueId('label-')
	 * // returns 'label-2'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter + '';
	  return prefix ? prefix + id : id;
	}
	
	/**
	 * AdLoader
	 *
	 * @param  {Object} opts
	 * @return {Object}
	 */
	function AdLoader(opts) {
	  var w = window;
	  var hasBeenInit = false;
	  var adSlots;
	
	  var defaultOpts = {
	    attributePrefix: 'dv-gpt-',
	    defaultAdFields: {
	      adUnit: '/5805113/basic',
	      dimensions: [300, 250]
	    },
	    globalMappings: {
	      banner: [[[768, 130], [[728, 90]]]],
	      smallBanner: [[[508, 100], [[468, 60]]]]
	    },
	    gptSrc: 'https://www.googletagservices.com/tag/js/gpt.js',
	    idPrefix: 'dv-gpt-',
	    selector: '.dv-gpt-ad',
	    targetingKey: 'tribpedia',
	    targetingValue: null
	  };
	
	  opts = objectAssign({}, defaultOpts, opts);
	
	  var adElements = Array.prototype.slice.call(document.querySelectorAll(opts.selector));
	
	  function setupService() {
	    w.googletag.cmd.push(function () {
	      var pubads = w.googletag.pubads();
	
	      if (opts.targetingKey && opts.targetingValue) {
	        pubads.setTargeting(opts.targetingKey, opts.targetingValue);
	      }
	
	      pubads.enableSingleRequest();
	      w.googletag.enableServices();
	    });
	  }
	
	  function createAds() {
	    adSlots = adElements.map(function (element) {
	      var matchingAttributes = getMatchingAttributes(element, opts.attributePrefix);
	      var localOpts = objectAssign({}, opts.defaultAdFields, matchingAttributes);
	
	      var adElementId = uniqueId(opts.idPrefix);
	      element.setAttribute('id', adElementId);
	
	      var adUnit = w.googletag.defineSlot(localOpts.adUnit, localOpts.dimensions, adElementId);
	
	      if (localOpts.mapping && opts.globalMappings.hasOwnProperty(localOpts.mapping)) {
	        adUnit.defineSizeMapping(opts.globalMappings[localOpts.mapping]);
	      }
	
	      if (localOpts.targetingKey && localOpts.targetingValue) {
	        adUnit.setTargeting(localOpts.targetingKey, localOpts.targetingValue);
	      }
	
	      adUnit.setCollapseEmptyDiv(true);
	      adUnit.addService(w.googletag.pubads());
	
	      w.googletag.display(adElementId);
	
	      return adUnit;
	    });
	  }
	
	  function init() {
	    if (hasBeenInit) return;
	
	    loadScript(w, opts.gptSrc, function () {
	      w.googletag.cmd.push(setupService, createAds);
	
	      hasBeenInit = true;
	    });
	  }
	
	  return {
	    adSlots: adSlots,
	    init: init
	  };
	}
	
	var dvAds = AdLoader(); // singleton
	
	exports.AdLoader = dvAds;

/***/ },

/***/ 33:
/***/ function(module, exports) {

	"use strict";
	
	/*!
	 * @preserve
	 * gascrolldepth.js | v0.9
	 * Copyright (c) 2015 Rob Flaherty (@robflaherty), Leigh McCulloch (@___leigh___)
	 * Licensed under the MIT and GPL licenses.
	 */
	(function (window, document, undefined) {
	
	  "use strict";
	
	  /*
	   * Extend a series of objects with the properties of each.
	   * Ref: http://stackoverflow.com/a/11197343/159762
	   */
	
	  function extend() {
	    for (var i = 1; i < arguments.length; i++) {
	      for (var key in arguments[i]) {
	        if (arguments[i].hasOwnProperty(key)) arguments[0][key] = arguments[i][key];
	      }
	    }return arguments[0];
	  }
	
	  /*
	   * Returns true if the element is in the array. Exact comparison is used.
	   */
	
	  function inArray(array, element) {
	    for (var i = 0; i < array.length; i++) {
	      if (array[i] === element) return true;
	    }return false;
	  }
	
	  /*
	   * Returns true if the object is an array.
	   */
	  function isArray(object) {
	    return Object.prototype.toString.call(object) === '[object Array]';
	  }
	
	  /*
	   * Reliably get the document height.
	   * Borrowed from:
	   * jQuery
	   * https://jquery.org/
	   * Ref: https://github.com/jquery/jquery/blob/a644101ed04d0beacea864ce805e0c4f86ba1cd1/src/dimensions.js#L33
	   * Copyright: jQuery Foundation and other contributors
	   * License: https://github.com/jquery/jquery/blob/a644101ed04d0beacea864ce805e0c4f86ba1cd1/LICENSE.txt
	   */
	
	  function getDocumentHeight() {
	    return Math.max(document.documentElement["scrollHeight"], document.body["scrollHeight"], document.documentElement["offsetHeight"], document.body["offsetHeight"], document.documentElement["clientHeight"]);
	  }
	
	  /*
	   * Reliably get the window height.
	   * Ref: http://www.w3schools.com/js/js_window.asp
	   */
	
	  function getWindowHeight() {
	    return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	  }
	
	  /*
	   * Reliably get the page y-axis offset due to scrolling.
	   * Ref: https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY
	   */
	
	  function getPageYOffset() {
	    return window.pageYOffset || (document.compatMode === "CSS1Compat" ? document.documentElement.scrollTop : document.body.scrollTop);
	  }
	
	  /*
	   * Reliably get the element's y-axis offset to the document top.
	   * Ref: https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
	   */
	
	  function getElementYOffsetToDocumentTop(element) {
	    return element.getBoundingClientRect().top + getPageYOffset();
	  }
	
	  /*
	   * Try really hard to get the first element matching a selector.
	   * Aims to support all browsers at least for selectors starting with `#`.
	   */
	
	  function getElementBySelector(selector) {
	    if (typeof window['jQuery'] !== 'undefined') {
	      return window['jQuery'](selector).get(0);
	    } else if (typeof document.querySelector !== 'undefined') {
	      return document.querySelector(selector);
	    } else if (selector.charAt(0) == '#') {
	      return document.getElementById(selector.substr(1));
	    }
	    return undefined;
	  }
	
	  /*
	   * Register and Deregister for `eventName` on `element`.
	   * Aims to support all browsers.
	   */
	
	  function addEventListener(element, eventName, handler) {
	    if (element.addEventListener) {
	      element.addEventListener(eventName, handler, false);
	    } else if (element.attachEvent) {
	      element.attachEvent('on' + eventName, handler);
	    } else {
	      element['on' + eventName] = handler;
	    }
	  }
	
	  function removeEventListener(element, eventName, handler) {
	    if (element.removeEventListener) {
	      element.removeEventListener(eventName, handler, false);
	    } else if (element.detachEvent) {
	      element.detachEvent('on' + eventName, handler);
	    } else {
	      element['on' + type] = null;
	    }
	  }
	
	  /*
	   * Module variables.
	   */
	  var defaults = {
	    minHeight: 0,
	    elements: [],
	    percentage: true,
	    userTiming: true,
	    pixelDepth: true,
	    nonInteraction: true,
	    gaGlobal: false,
	    gtmOverride: false
	  };
	
	  var options = extend({}, defaults),
	      cache = [],
	      scrollEventBound = false,
	      lastPixelDepth = 0,
	      universalGA,
	      classicGA,
	      gaGlobal,
	      standardEventHandler,
	      scrollEventHandler;
	
	  /*
	   * Bind and unbind the scroll event handler.
	   */
	
	  function bindScrollDepth(scrollEventHandler) {
	    scrollEventBound = true;
	    addEventListener(window, 'scroll', scrollEventHandler);
	  }
	
	  function unbindScrollDepth(scrollEventHandler) {
	    scrollEventBound = false;
	    removeEventListener(window, 'scroll', scrollEventHandler);
	  }
	
	  /*
	   * Library Interface
	   */
	
	  // Initialize the library.
	  var init = function init(initOptions) {
	
	    var startTime = +new Date();
	
	    options = extend({}, defaults, initOptions);
	
	    // Return early if document height is too small
	    if (getDocumentHeight() < options.minHeight) {
	      return;
	    }
	
	    /*
	     * Determine which version of GA is being used
	     * "ga", "__gaTracker", _gaq", and "dataLayer" are the possible globals
	     */
	
	    if (options.gaGlobal) {
	      universalGA = true;
	      gaGlobal = options.gaGlobal;
	    } else if (typeof ga === "function") {
	      universalGA = true;
	      gaGlobal = 'ga';
	    } else if (typeof __gaTracker === "function") {
	      universalGA = true;
	      gaGlobal = '__gaTracker';
	    }
	
	    if (typeof _gaq !== "undefined" && typeof _gaq.push === "function") {
	      classicGA = true;
	    }
	
	    if (typeof options.eventHandler === "function") {
	      standardEventHandler = options.eventHandler;
	    } else if (typeof dataLayer !== "undefined" && typeof dataLayer.push === "function" && !options.gtmOverride) {
	
	      standardEventHandler = function standardEventHandler(data) {
	        dataLayer.push(data);
	      };
	    }
	
	    /*
	     * Functions
	     */
	
	    function sendEvent(action, label, scrollDistance, timing) {
	
	      if (standardEventHandler) {
	
	        standardEventHandler({ 'event': 'ScrollDistance', 'eventCategory': 'Scroll Depth', 'eventAction': action, 'eventLabel': label, 'eventValue': 1, 'eventNonInteraction': options.nonInteraction });
	
	        if (options.pixelDepth && arguments.length > 2 && scrollDistance > lastPixelDepth) {
	          lastPixelDepth = scrollDistance;
	          standardEventHandler({ 'event': 'ScrollDistance', 'eventCategory': 'Scroll Depth', 'eventAction': 'Pixel Depth', 'eventLabel': rounded(scrollDistance), 'eventValue': 1, 'eventNonInteraction': options.nonInteraction });
	        }
	
	        if (options.userTiming && arguments.length > 3) {
	          standardEventHandler({ 'event': 'ScrollTiming', 'eventCategory': 'Scroll Depth', 'eventAction': action, 'eventLabel': label, 'eventTiming': timing });
	        }
	      } else {
	
	        if (universalGA) {
	
	          window[gaGlobal]('send', 'event', 'Scroll Depth', action, label, 1, { 'nonInteraction': options.nonInteraction });
	
	          if (options.pixelDepth && arguments.length > 2 && scrollDistance > lastPixelDepth) {
	            lastPixelDepth = scrollDistance;
	            window[gaGlobal]('send', 'event', 'Scroll Depth', 'Pixel Depth', rounded(scrollDistance), 1, { 'nonInteraction': options.nonInteraction });
	          }
	
	          if (options.userTiming && arguments.length > 3) {
	            window[gaGlobal]('send', 'timing', 'Scroll Depth', action, timing, label);
	          }
	        }
	
	        if (classicGA) {
	
	          _gaq.push(['_trackEvent', 'Scroll Depth', action, label, 1, options.nonInteraction]);
	
	          if (options.pixelDepth && arguments.length > 2 && scrollDistance > lastPixelDepth) {
	            lastPixelDepth = scrollDistance;
	            _gaq.push(['_trackEvent', 'Scroll Depth', 'Pixel Depth', rounded(scrollDistance), 1, options.nonInteraction]);
	          }
	
	          if (options.userTiming && arguments.length > 3) {
	            _gaq.push(['_trackTiming', 'Scroll Depth', action, timing, label, 100]);
	          }
	        }
	      }
	    }
	
	    function calculateMarks(docHeight) {
	      return {
	        '25%': parseInt(docHeight * 0.25, 10),
	        '50%': parseInt(docHeight * 0.50, 10),
	        '75%': parseInt(docHeight * 0.75, 10),
	        // Cushion to trigger 100% event in iOS
	        '100%': docHeight - 5
	      };
	    }
	
	    function checkMarks(marks, scrollDistance, timing) {
	      // Check each active mark
	      for (var key in marks) {
	        if (!marks.hasOwnProperty(key)) continue;
	        var val = marks[key];
	        if (!inArray(cache, key) && scrollDistance >= val) {
	          sendEvent('Percentage', key, scrollDistance, timing);
	          cache.push(key);
	        }
	      }
	    }
	
	    function checkElements(elements, scrollDistance, timing) {
	      for (var i = 0; i < elements.length; i++) {
	        var elem = elements[i];
	        if (!inArray(cache, elem)) {
	          var elemNode = typeof elem === "string" ? getElementBySelector(elem) : elem;
	          if (elemNode) {
	            var elemYOffset = getElementYOffsetToDocumentTop(elemNode);
	            if (scrollDistance >= elemYOffset) {
	              sendEvent('Elements', elem, scrollDistance, timing);
	              cache.push(elem);
	            }
	          }
	        }
	      };
	    }
	
	    function rounded(scrollDistance) {
	      // Returns String
	      return (Math.floor(scrollDistance / 250) * 250).toString();
	    }
	
	    /*
	     * Throttle function borrowed from:
	     * Underscore.js 1.5.2
	     * http://underscorejs.org
	     * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	     * Underscore may be freely distributed under the MIT license.
	     */
	
	    function throttle(func, wait) {
	      var context, args, result;
	      var timeout = null;
	      var previous = 0;
	      var later = function later() {
	        previous = new Date();
	        timeout = null;
	        result = func.apply(context, args);
	      };
	      return function () {
	        var now = new Date();
	        if (!previous) previous = now;
	        var remaining = wait - (now - previous);
	        context = this;
	        args = arguments;
	        if (remaining <= 0) {
	          clearTimeout(timeout);
	          timeout = null;
	          previous = now;
	          result = func.apply(context, args);
	        } else if (!timeout) {
	          timeout = setTimeout(later, remaining);
	        }
	        return result;
	      };
	    }
	
	    /*
	     * Scroll Event
	     */
	
	    scrollEventHandler = throttle(function () {
	      /*
	       * We calculate document and window height on each scroll event to
	       * account for dynamic DOM changes.
	       */
	
	      var docHeight = getDocumentHeight(),
	          winHeight = getWindowHeight(),
	          scrollDistance = getPageYOffset() + winHeight,
	
	
	      // Recalculate percentage marks
	      marks = calculateMarks(docHeight),
	
	
	      // Timing
	      timing = +new Date() - startTime;
	
	      // If all marks already hit, unbind scroll event
	      if (cache.length >= 4 + options.elements.length) {
	        unbindScrollDepth();
	        return;
	      }
	
	      // Check specified DOM elements
	      if (options.elements) {
	        checkElements(options.elements, scrollDistance, timing);
	      }
	
	      // Check standard marks
	      if (options.percentage) {
	        checkMarks(marks, scrollDistance, timing);
	      }
	    }, 500);
	
	    bindScrollDepth(scrollEventHandler);
	  };
	
	  // Reset Scroll Depth with the originally initialized options
	  var reset = function reset() {
	    cache = [];
	    lastPixelDepth = 0;
	
	    if (typeof scrollEventHandler == "undefined") {
	      return;
	    }
	
	    unbindScrollDepth(scrollEventHandler);
	    bindScrollDepth(scrollEventHandler);
	  };
	
	  // Add DOM elements to be tracked
	  var addElements = function addElements(elems) {
	    if (typeof elems == "undefined" || !isArray(elems)) {
	      return;
	    }
	
	    for (var i = 0; i < elems.length; i++) {
	      var elem = elems[i];
	      var elemIndex = options.elements.indexOf(elem);
	      if (elemIndex == -1) {
	        options.elements.push(elem);
	      }
	    }
	
	    if (!scrollEventBound) {
	      bindScrollDepth();
	    }
	  };
	
	  // Remove DOM elements currently tracked
	  var removeElements = function removeElements(elems) {
	    if (typeof elems == "undefined" || !isArray(elems)) {
	      return;
	    }
	
	    for (var i = 0; i < elems.length; i++) {
	      var elem = elems[i];
	
	      var elementsIndex = options.elements.indexOf(elem);
	      if (elementsIndex > -1) {
	        options.elements.splice(elementsIndex, 1);
	      }
	
	      var cacheIndex = cache.indexOf(elem);
	      if (cacheIndex > -1) {
	        cache.splice(cacheIndex, 1);
	      }
	    }
	  };
	
	  /*
	   * Globals
	   */
	
	  window.gascrolldepth = {
	    init: init,
	    reset: reset,
	    addElements: addElements,
	    removeElements: removeElements
	  };
	
	  /*
	   * jQuery Plugin
	   */
	
	  if (typeof window['jQuery'] !== 'undefined') {
	    window['jQuery'].gascrolldepth = init;
	  }
	})(window, document);
	
	window.gascrolldepth.init();

/***/ },

/***/ 39:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EventObserver = __webpack_require__(10);
	
	var _EventObserver2 = _interopRequireDefault(_EventObserver);
	
	var _raf = __webpack_require__(11);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * `scrollWatcher` alerts any listeners when window's `scroll` event fires.
	 * Intelligently doesn't activate the event listener unless it is needed, and
	 * will clear the listener if nothing needs it.
	 */
	function scrollWatcher() {
	  var observer = new _EventObserver2.default();
	  var lastScrollPosition = 0;
	  var active = false;
	
	  function onWindowScroll() {
	    requestTick();
	  }
	
	  function requestTick() {
	    lastScrollPosition = window.scrollY || window.pageYOffset;
	
	    if (!active) {
	      (0, _raf2.default)(update);
	      active = true;
	    }
	  }
	
	  function update() {
	    observer.trigger('scroll', { offset: lastScrollPosition });
	    active = false;
	  }
	
	  return {
	    /**
	     * Adds a new listener to `scrollWatcher`. Doesn't set the event listener
	     * for the `scroll` event until at least one is added.
	     *
	     * @memberof scrollWatcher
	     * @param {Function} callback
	     * @return {void}
	     */
	    add: function add(callback) {
	      if (!observer.eventHasListeners('scroll')) {
	        window.addEventListener('scroll', onWindowScroll, false);
	      }
	
	      observer.on('scroll', callback);
	    },
	
	    /**
	     * Removes a listener from `scrollWatcher`. If there are no more listeners
	     * active, the `scroll` event listener is unset.
	     *
	     * @memberof scrollWatcher
	     * @param  {Function} callback
	     * @return {void}
	     */
	    remove: function remove(callback) {
	      observer.off('scroll', callback);
	
	      if (!observer.eventHasListeners('scroll')) {
	        window.removeEventListener('scroll', onWindowScroll, false);
	      }
	    },
	
	    /**
	     * Removes all listeners on `scrollWatcher`.
	     *
	     * @memberof scrollWatcher
	     * @return {void}
	     */
	    clear: function clear() {
	      observer.clearAllListeners('scroll');
	      window.removeEventListener('scroll', onWindowScroll, false);
	    }
	  };
	}
	
	exports.default = scrollWatcher(); // singleton

/***/ }

});


/** WEBPACK FOOTER **
 ** story.js
 **/